import { _ as _slicedToArray } from '../slicedToArray-b4278ecd.js';
import { useState, useCallback, useEffect } from 'react';
import IS_BROWSER from '../isBrowser/index.js';

function useDelayedScript(url) {
  var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var defer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isScriptLoaded = _useState2[0],
    setIsScriptLoaded = _useState2[1];
  var loadScript = useCallback(function (src) {
    if (document) {
      var script = document.createElement('script');
      script.src = src;
      script.async = async;
      script.defer = defer;
      if (document.body) {
        document.body.append(script);
        script.onload = function () {
          setIsScriptLoaded(true); // setting flag true here
        };
      }
    }
  }, [async, defer]);
  useEffect(function () {
    IS_BROWSER && loadScript(url);
  }, [url, loadScript]);
  return isScriptLoaded;
}

export { useDelayedScript as default };
//# sourceMappingURL=index.js.map
